import { connect } from 'react-redux'
import { UploadDocumentsStepComponent } from './UploadDocumentsStep'
import { uploadMobileServiceDocument } from 'features/Files/Files.actions'

export interface IUploadedFile {
  file: File
  hash: string
}

const stateToProps = ({ files }) => {
  const name = 'mobileServiceUploadDocumentsStep'
  const file = files[name] || {}
  return {
    loading: file.loading || false,
    name,
  }
}

const dispatchToProps = {
  uploadMobileServiceDocument,
}

export const UploadDocumentsStep = connect(
  stateToProps,
  dispatchToProps
)(UploadDocumentsStepComponent)



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/UploadDocumentsStep/UploadDocumentsStep.container.ts